module.exports = __webpack_public_path__ + "img/bullhorn.fa697eff.png";